module.exports = __webpack_public_path__ + "static/media/bluerate.65559650.svg";